/**
 * Cold Scenario Service
 *
 * Handles Flux Cold Storage scenario API calls:
 * - CRUD for cold storage scenarios
 * - Duplicate scenarios
 *
 * Convention: currentUser is always the last parameter
 */

import { apiGet, apiPost, apiPut, apiDelete, handleApiResponse, API_BASE_URL } from '@vortx/shared-ui';

const COLD_API = '/api/cold_storage/v1';

// ============================================================
// Scenarios
// ============================================================

export async function getColdScenarios(projectId, currentUser) {
    const response = await apiGet(
        `${COLD_API}/projects/${projectId}/scenarios`,
        currentUser
    );
    const data = await handleApiResponse(response);
    return data.scenarios || [];
}

export async function getColdScenario(projectId, scenarioId, currentUser) {
    const response = await apiGet(
        `${COLD_API}/projects/${projectId}/scenarios/${scenarioId}`,
        currentUser
    );
    return handleApiResponse(response);
}

export async function createColdScenario(projectId, name, currentUser) {
    const response = await apiPost(
        `${COLD_API}/projects/${projectId}/scenarios`,
        { name },
        currentUser
    );
    return handleApiResponse(response);
}

export async function updateColdScenario(projectId, scenarioId, updates, currentUser) {
    const response = await apiPut(
        `${COLD_API}/projects/${projectId}/scenarios/${scenarioId}`,
        updates,
        currentUser
    );
    return handleApiResponse(response);
}

export async function deleteColdScenario(projectId, scenarioId, currentUser) {
    const response = await apiDelete(
        `${COLD_API}/projects/${projectId}/scenarios/${scenarioId}`,
        currentUser
    );
    if (!response.ok) {
        let errorDetail;
        try {
            const data = await response.json();
            errorDetail = data.error || data.message || data.detail;
        } catch (e) {
            // Response body wasn't JSON
        }
        throw new Error(errorDetail || `HTTP ${response.status}: ${response.statusText}`);
    }
}

export async function duplicateColdScenario(projectId, scenarioId, currentUser) {
    const response = await apiPost(
        `${COLD_API}/projects/${projectId}/scenarios/${scenarioId}/duplicate`,
        {},
        currentUser
    );
    return handleApiResponse(response);
}
